<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { derived } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { lg } from 'hydria/services/language'
    import { backendStatus, revalidating, session, signedIn, simpleFetch, type SimpleFetchResult } from 'hydria/services/session'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    const effSessionStatus = derived([signedIn, backendStatus], ([$signedIn, $backendStatus]) => {
        if (!$signedIn) return 'signed-out'
        return $backendStatus
    })

    let conditionModalOpened = $state(false)
    let modalClassesAreOurs = false
    // let loadedTexts = false

    let texts: { [key: string]: string } = $state({
        'backend-down-fr': '<p>Les serveurs de WebDomaine semblent être en maintenance. Veuillez patientez quelque minutes.</p>',
        'backend-down-en': '<p>WebDomaine seems to be in maintenance mode. Please wait a moment.</p>',
        'backend-unreachable-fr': '<p>La connection avec les serveurs de WebDomaine est rompue. Veuillez patientez un moment.</p>',
        'backend-unreachable-en': '<p>WebDomaine is unreachable. Please wait a moment.</p>',
    })

    export async function signout() {
        await session.signout(true)
    }

    onMount(() => {
        loadTexts()
    })

    async function loadTexts() {
        let r: SimpleFetchResult
        try {
            r = await simpleFetch('GET', '/json/general/1/backend-condition-texts', null, { cache: 'default' })
        } catch (e) {
            console.error('Backend condition texts could not be loaded:', e)
            // loadedTexts = true
            return
        }

        texts = r.data.texts
        // loadedTexts = true
    }

    function openModal() {
        if (conditionModalOpened) return

        modalClassesAreOurs = !document.documentElement.classList.contains('modal-open')
        if (modalClassesAreOurs) {
            document.documentElement.classList.add('modal-open')
        }

        conditionModalOpened = true
    }

    function closeModal() {
        if (!conditionModalOpened) return

        if (modalClassesAreOurs && document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }

        conditionModalOpened = false
    }

    unsubs.push(
        effSessionStatus.subscribe((nv) => {
            if (nv == 'signed-out' || nv == 'ok') {
                closeModal()
            } else {
                openModal()
            }
        }),
    )
</script>

<style>
    .modal {
        z-index: 10000;
    }
</style>

{#if conditionModalOpened}
    <div class="modal" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-bg-warning">
                    <div>
                        {#if $backendStatus == 'unreachable'}
                            {$_('Connection lost')}
                        {:else}
                            {$_('Maintenance')}
                        {/if}
                    </div>
                </div>
                <div class="modal-body">
                    {@html texts[`backend-${$backendStatus}-${$lg}`]}
                </div>
                <div class="modal-footer text-bg-light">
                    <div style="width: 100%; display: grid; grid-template-columns: 1fr auto; gap: 1.5rem;">
                        <div class="text-muted" style="text-align: left;">
                            {#if $revalidating}
                                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                {$_('Attempting to connect…')}
                            {/if}
                        </div>
                        <div>
                            <button class="btn btn-primary" type="button" onclick={() => signout()}>
                                {$_('Close the session')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop"></div>
    </div>
{/if}
